export default __webpack_public_path__ + "static/media/Credly_CPENT_Badge_Upload.f03720b2.png";